import {
  formatIST,
} from "../utils";

export default function CompactLeadDetails({
  lead,
}) {
  return (
    <div className="mt-4">
      <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs sm:grid-cols-3">
        <Info
          label="Phone"
          value={
            lead.leadDetails?.phone
          }
        />

        <Info
          label="Email"
          value={
            lead.leadDetails?.email
          }
        />

        <Info
          label="Country"
          value={
            lead.leadDetails?.country
          }
        />

        <Info
          label="Assigned"
          value={
            lead.assignedTo
          }
        />

        <Info
          label="Retry"
          value={`${Number(
            lead.retryCount || 0
          )}/4`}
        />

        {
          lead?.nextRetryAt ?
            <Info
              label="Next Retry"
              value={`${formatIST(
                lead.nextRetryAt
              )} IST`}
            /> :
            <Info
              label="Next Follow-up"
              value={
                lead.nextFollowupAt
                  ? `${formatIST(
                    lead.nextFollowupAt
                  )} IST`
                  : "—"
              }
            />
        }

         <Info
          label="level"
          value={
            lead.level || "—"
          }
        />

         <Info
          label="1st Asignee"
          value={
            lead.callDetails[0]?.callBy || lead.assignedTo || "—"
          }
        />

      </div>

      {!!lead.leadDetails
        ?.questionanswers?.length && (
          <details className="mt-3 rounded-lg bg-slate-50 px-3 py-2">
            <summary className="cursor-pointer text-xs font-medium text-slate-600">
              Lead Answers (
              {
                lead.leadDetails
                  .questionanswers
                  .length
              }
              )
            </summary>

            <div className="mt-2 space-y-1.5">
              {lead.leadDetails.questionanswers.map(
                (answer, index) => (
                  <p
                    key={index}
                    className="text-xs text-slate-600"
                  >
                    {index + 1}.{" "}
                    {answer}
                  </p>
                )
              )}
            </div>
          </details>
        )}
    </div>
  );
}

function Info({
  label,
  value,
}) {
  return (
    <div className="min-w-0">
      <p className="text-[10px] uppercase tracking-wide text-slate-400">
        {label}
      </p>

      <p className="truncate font-medium text-slate-700">
        {value === 0
          ? 0
          : value || "—"}
      </p>
    </div>
  );
}